<template>
  <div class="page-content">
    <div class="container-fluid">
      <!-- start page title -->
      <div class="row">
        <div class="col-12">
          <div class="page-title-box d-sm-flex align-items-center justify-content-between">
            <h4 class="mb-sm-0" v-text="jenis_name()"></h4>

            <div class="page-title-right">
              <ol class="breadcrumb m-0">
                <li class="breadcrumb-item">
                  <Link :href="`/admin/portal/${jenis}`" v-text="jenis_name()"></Link>
                </li>
              </ol>
            </div>
          </div>
        </div>
      </div>
      <!-- end page title -->

      <div class="row">
        <div class="col-lg-12">
          <div class="card">
            <div class="card-body">
              <div class="d-flex justify-content-between">
                <div>
                  <h4 class="card-title">Manajemen {{ jenis_name() }}</h4>
                  <p class="card-title-desc mb-0"><i>Content Management System</i> terkait Berita/Artikel/Postingan atau halaman tertentu yang nantinya akan tampil pada halaman muka.</p>
                </div>
                <div>
                  <!-- <button type="button" class="btn btn-success" @click="form.show = true">Tambah Baru</button> -->
                  <Link :href="`/admin/portal/editor/${jenis}`" class="btn btn-success">Tambah Baru</Link>
                </div>
              </div>

              <hr>

              <div class="table-responsive">
                <table class="table mb-0">
                  <thead>
                    <tr>
                      <th class="text-center">No</th>
                      <th>Judul</th>
                      <th>Status</th>
                      <th>Perubahan Terakhir</th>
                      <th class="text-center">Aksi</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(row, index) in list_postingan" :key="index">
                      <td scope="row" class="text-center">{{ index + 1 }}</td>
                      <td scope="row" v-text="row.title"></td>
                      <td scope="row" v-text="row.status_postingan"></td>
                      <td scope="row">{{ (new Date(row.updated_at)).toLocaleString() }}</td>
                      <td scope="row" class="text-center">
                        <a :href="(jenis == 'posts' ? '/postingan' : '') + '/' + row.slug" target="_blank" class="p-0 btn btn-sm btn-link">Lihat</a> | 
                        <Link :href="`/admin/portal/editor/${jenis}/${row.id}`" class="p-0 btn btn-sm btn-link">Edit</Link> | 
                        <a @click="remove(row)" class="p-0 btn btn-sm btn-link">Hapus</a>
                      </td>
                    </tr>
                    <tr v-if="list_postingan.length == 0">
                      <td scope="row" colspan="6" class="text-center">
                        <i>Tidak ditemukan data!</i>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- end row -->
    </div>
    <!-- container-fluid -->
  </div>
</template>

<script>
import Layout from '@/layout/Index'
import Modal from '@/components/Modal'
import throttle from 'lodash/throttle'
import pickBy from 'lodash/pickBy'

export default {
  layout: Layout,
  components: { Modal },
  props: {
    list_postingan: Array,
    jenis: String
  },
  data() {

  },
  methods: {
    jenis_name() {
      switch(this.jenis) {
        case 'posts': return 'Postingan';
        case 'pages': return 'Artikel';
        default: return '-';
      }
    },
    remove(row) {
      if(confirm('yakin hapus?'))
        this.$inertia.delete('/admin/portal/' + this.jenis + '/' + row.id);
    }
  },
}
</script>
